module.exports = __webpack_public_path__ + "img/Lucia.cec9058b.jpg";